/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

export type LoanApplicationStatus = typeof LoanApplicationStatus[keyof typeof LoanApplicationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoanApplicationStatus = {
  DRAFT: 'DRAFT',
  LEAD_PROCESSING: 'LEAD_PROCESSING',
  PENDING_SUBMISSION: 'PENDING_SUBMISSION',
  SUBMITTED: 'SUBMITTED',
  DOCUMENT_COLLECTION: 'DOCUMENT_COLLECTION',
  VERIFICATION_IN_PROGRESS: 'VERIFICATION_IN_PROGRESS',
  VERIFICATION_REJECTED: 'VERIFICATION_REJECTED',
  VERIFICATION_COMPLETE: 'VERIFICATION_COMPLETE',
  EVALUATION_IN_PROGRESS: 'EVALUATION_IN_PROGRESS',
  REJECTED_EVALUATION: 'REJECTED_EVALUATION',
  COMMITTEE_APPROVAL: 'COMMITTEE_APPROVAL',
  REJECTED_COMMITTEE: 'REJECTED_COMMITTEE',
  AGREEMENT_PREPARATION: 'AGREEMENT_PREPARATION',
  AGREEMENT_READY: 'AGREEMENT_READY',
  AGREEMENT_UPLOAD: 'AGREEMENT_UPLOAD',
  COLLATERAL_VERIFICATION: 'COLLATERAL_VERIFICATION',
  REJECTED_COLLATERAL: 'REJECTED_COLLATERAL',
  PENDING_DISBURSEMENT: 'PENDING_DISBURSEMENT',
  DISBURSEMENT_IN_PROGRESS: 'DISBURSEMENT_IN_PROGRESS',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
